<template>
  <v-container id="dashboard" fluid tag="section">
    <!-- OPTIONS & MANAGEMENT WIDGETS -->
    <v-row v-if="userLevelAboveAdmin">
      <v-col cols="12">
        <v-card class="my-0">
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" md="6">
                  <DateRangePicker
                    @update="onDateRangeUpdated"
                    :def-dates="dates"
                    :show-clear-btn="true"
                  >
                  </DateRangePicker>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="6" lg="3">
                  <v-text-field
                    dense
                    outlined
                    v-model="form.search.operatorBy"
                    placeholder="搜尋操作者"
                    clearable
                  >
                  </v-text-field>
                </v-col>
                <!-- <v-col cols="12" md="6" lg="3">
                  <v-text-field
                      dense
                      outlined
                      v-model="form.search.target"
                      placeholder="搜尋操作對象"
                      clearable
                    >
                  </v-text-field>
                </v-col> -->
                <!-- 操作選單 -->
                <v-col
                  v-for="config in filters"
                  :key="config.key"
                  cols="12"
                  md="6"
                  lg="3"
                >
                  <v-select
                    v-model="form.search[config.key]"
                    :items="config.options"
                    :label="config.label"
                    :placeholder="config.placeholder"
                    item-text="label"
                    item-value="value"
                    dense
                    outlined
                    clearable
                  ></v-select>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- LIST OF logs -->
    <v-row>
      <v-col cols="12">
        <v-card>
          <v-card-text>
            <SSRTable
              ref="log-list"
              :data-url="loadUrl"
              :data-key="'data'"
              :schema="schema"
              @load-data="resetExpandedItems(); resetExpandedErrors();"
            >
              <!-- 時間 -->
              <div slot="createdAt" slot-scope="{ item }">
                {{ formatDate(item.createdAt) }}
              </div>
              <div slot="category" slot-scope="{ item }">
                {{ getFilterOptionText("category", item.category) }}
              </div>
              <div slot="action" slot-scope="{ item }">
                {{ getFilterOptionText("action", item.action) }}
              </div>
              <div slot="targetId" slot-scope="{ item }">
                {{ item.targetId }}
                {{ item.targetName ? `- ${item.targetName}` : "" }}
              </div>
              <div
                slot="afterData"
                slot-scope="{ item }"
              >
                <div :class="{ 'truncate-text': !expandedItems[item.id] }">
                  {{ item.afterData }}
                </div>
                <div v-if="item.afterData" class="d-flex justify-end">
                  <v-btn
                    small
                    rounded
                    depressed
                    :color="
                      expandedItems[item.id] ? 'red darken-1' : 'blue darken-1'
                    "
                    @click="toggleExpand(item.id)"
                  >
                    {{
                      expandedItems[item.id]
                        ? $t("logs.collapse")
                        : $t("logs.expand")
                    }}
                  </v-btn>
                </div>
              </div>
              <div slot="responseStatus" slot-scope="{ item }">
                <span v-if="item.errorMessage">
                  <v-icon color="red">mdi-message-alert-outline</v-icon>
                  {{ item.responseStatus }} <br />
                  [ {{ item.requestMethod }}] {{ item.requestPath }} <br />
                   <div :class="{ 'truncate-text': !expandedErrors[item.id] }">
                      {{ item.errorMessage }}
                    </div>
                    <div v-if="item.errorMessage" class="d-flex justify-end">
                      <v-btn
                        small
                        rounded
                        depressed
                        :color="
                          expandedErrors[item.id] ? 'red darken-1' : 'blue darken-1'
                        "
                        @click="toggleExpandError(item.id)"
                      >
                        {{
                          expandedErrors[item.id]
                            ? $t("logs.collapse")
                            : $t("logs.expand")
                        }}
                      </v-btn>
                    </div>
                </span>
                <span v-else>
                  <v-icon color="green">mdi-check-bold</v-icon>
                </span>
              </div>
              <div slot="actions" slot-scope="{ item }"></div>
            </SSRTable>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import SSRTable from "@/components/SSRTable";
import DateRangePicker from "@/components/DateRangePicker";

import axios from "axios";
import moment from "moment";

export default {
  components: {
    SSRTable,
    DateRangePicker
  },

  mounted() {
    this.fetchFilters();
  },

  methods: {
    onDateRangeUpdated(dates) {
      this.dates = dates;
    },
    formatDate(ts) {
      return new Date(ts * 1000).toLocaleString();
    },
    async fetchFilters() {
      try {
        let response = await axios.get(
          `${process.env.VUE_APP_QRPAY_ADMIN_HOST}/api/operation-logs/options`
        );
        this.filters = response.data.data;
        // 初始化 form.search 的欄位
        this.filters.forEach(config => {
          this.$set(this.form.search, config.key, null);
        });
      } catch (err) {
        console.error(`Failed to fetch filter options`, err);
        throw err;
      }
    },
    getFilterOptionText(key, value) {
      const config = this.filters.find(cfg => cfg.key === key);
      if (config) {
        const item = config?.options.find(opt => opt.value === value);
        return item ? item.label : value;
      }
      return value;
    },
    toggleExpand(id) {
      this.$set(this.expandedItems, id, !this.expandedItems[id]);
    },

    resetExpandedItems() {
      this.expandedItems = {};
    },

    toggleExpandError(id) {
      this.$set(this.expandedErrors, id, !this.expandedErrors[id]);
    },
    resetExpandedErrors() {
      this.expandedErrors = {};
    }
  },

  data() {
    return {
      dates: [],
      scope: {},
      filters: [],
      expandedItems: {},
      expandedErrors: {},
      form: {
        search: {
          searchBy: "",
          keyword: "",
          searchQueryString: ""
        }
      }
    };
  },
  watch: {
    // selectedParamsString() {
    //   this.resetExpandedItems();
    // }
  },

  computed: {
    selectedParamsString() {
      const entries = Object.entries(this.form.search)
        .filter(([_, value]) => value !== null && value !== "") // 忽略未選取的
        .map(([key, value]) => `${key}:${value}`);

      let paramsString = entries.join(",");
      let from = this.dates.length
        ? moment(this.dates[0]).format("YYYY-MM-DD")
        : null;
      let to =
        this.dates.length > 1
          ? moment(this.dates[1])
              .endOf("day")
              .format("YYYY-MM-DD")
          : null;
      if (from && to) {
        paramsString += paramsString.length ? `,startDate:${from},endDate:${to}` : `startDate:${from},endDate:${to}` ;
      }
      return paramsString;
    },
    loadUrl() {
      return (
        `${process.env.VUE_APP_QRPAY_ADMIN_HOST}/api/operation-logs` +
        (this.selectedParamsString
          ? `?searchBy=${this.selectedParamsString}`
          : "")
      );
    },

    schema() {
      let ret = [
        {
          text: this.$t("logs.createdAt"),
          value: "createdAt",
          width: "5%",
          sortable: false
        },
        {
          text: this.$t("logs.operatorBy"),
          value: "operatorBy",
          width: "5%",
          sortable: false
        },
        { text: this.$t("logs.category"), value: "category", sortable: false, width: "5%", },
        { text: this.$t("logs.action"), value: "action", sortable: false, width: "5%", },
        // { text: '操作對象', value: 'targetId', sortable: false },
        // { text: '操作前內容', value: 'beforeData', sortable: false },
        {
          text: this.$t("logs.afterData"),
          value: "afterData",
          width: "50%",
          sortable: false
        },
        {
          text: this.$t("logs.responseStatus"),
          value: "responseStatus",
          width: "30%",
          sortable: false
        }
      ];
      return ret;
    },

    user() {
      return this.$store.getters.user;
    },
    userLevelAboveAdmin() {
      return ["superadmin"].indexOf(this.$store.getters.user["level"]) >= 0;
    }
  }
};
</script>

<style scoped>
.truncate-text {
  max-height: 3.6em; /* 約兩行文字高度 */
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
  display: -webkit-box;
  -webkit-line-clamp: 2; /* 限制顯示行數 */
  -webkit-box-orient: vertical;
}


</style>
